
    import {Component, Vue} from 'vue-property-decorator';
    import {Scenario} from "@/scenarios/Scenarios";
    import {Lambda} from "@/simulation/Lambda";
    import {Sqs} from "@/simulation/Sqs";
    import BrowserWindow from "@/landing/BrowserWindow.vue";
    import Slide from '@/talk/Slide.vue';
    import {ExternalApi} from '@/simulation/ExternalApi';
    import {EventBridge} from '@/simulation/EventBridge';

    @Component({
        components: {
            Slide,
            BrowserWindow,
        }
    })
    export default class Landing extends Vue {
        events: Array<any> = [];
        nextEventDelay = 20;
        sqs = new class extends Scenario {
            constructor() {
                super();
                const sqsLambda = new Lambda;
                sqsLambda.averageDuration = 2000;
                const sqs = new Sqs;
                sqs.name = 'SQS queue';
                sqs.connectToLambda(sqsLambda);
                this.services.push(sqs);
                this.services.push(sqsLambda);
            }
        };
        sqsThrottling = new class extends Scenario {
            constructor() {
                super();
                const sqsLambda = new Lambda;
                sqsLambda.maxConcurrency = 5;
                sqsLambda.averageDuration = 1500;
                const sqs = new Sqs;
                sqs.name = 'SQS queue';
                sqs.connectToLambda(sqsLambda);
                this.services.push(sqs);
                this.services.push(sqsLambda);
            }
        };
        sqsErrors = new class extends Scenario {
            constructor() {
                super();
                const sqsLambda = new Lambda;
                const sqs = new Sqs;
                sqs.connectToLambda(sqsLambda);
                const api = new ExternalApi;
                api.name = 'Twitter';
                api.errorRate = 70;
                sqsLambda.connectToApi(api);
                this.services.push(sqs);
                this.services.push(sqsLambda);
                this.services.push(api);
            }
        };
        sqsDlq = new class extends Scenario {
            constructor() {
                super();
                const sqsLambda = new Lambda;
                const dlq = new Sqs;
                dlq.name = 'DLQ (SQS)';
                const sqs = new Sqs;
                sqs.connectToLambda(sqsLambda);
                sqs.retryCount = 2;
                sqs.connectToDlq(dlq);
                const api = new ExternalApi;
                api.name = 'Twitter';
                api.errorRate = 100;
                sqsLambda.connectToApi(api);
                this.services.push(sqs);
                this.services.push([sqsLambda, dlq]);
                this.services.push(api);
            }
        };
        eventBridgeDlq = new class extends Scenario {
            constructor() {
                super();
                const lambda1 = new Lambda;
                lambda1.name = 'VideoUpload';
                const eventBridgeLambda1 = new Lambda;
                eventBridgeLambda1.name = 'CreateThumbnail';
                eventBridgeLambda1.errorRate = 50;
                const eventBridgeLambda2 = new Lambda;
                eventBridgeLambda2.name = 'UpdateSearchIndex';
                eventBridgeLambda2.maxConcurrency = 3;
                eventBridgeLambda2.errorRate = 50;
                // DLQ
                const dlq = new Sqs;
                dlq.name = 'DLQ (SQS)';
                eventBridgeLambda1.connectToDlq(dlq);
                eventBridgeLambda2.connectToDlq(dlq);

                const eventBridge = new EventBridge();
                lambda1.connectToEventBridge(eventBridge);
                eventBridge.connectToLambda(eventBridgeLambda1);
                eventBridge.connectToLambda(eventBridgeLambda2);

                this.services.push(lambda1);
                this.services.push(eventBridge);
                this.services.push([eventBridgeLambda1, eventBridgeLambda2]);
                this.services.push(dlq);
            }
        };

        fullscreen() {
            document.getElementsByTagName('html')[0].requestFullscreen();
        }
        onAnimationVisible(isVisible: boolean) {
            if (isVisible) {
                window.setTimeout(() => this.addEvent(), 500);
            }
        }
        addEvent() {
            const max = 47;
            if (this.events.length >= max) {
                return;
            }
            const event = {
                id: this.events.length,
                opacity: 100 - Math.round(this.events.length / (max + 1) * 100),
                visible: false,
                kill: false,
            };
            this.events.push(event);
            window.setTimeout(() => {
                event.visible = true;
            }, 50);
            this.nextEventDelay = this.nextEventDelay * 1.05;
            window.setTimeout(() => {
                this.addEvent()
            }, this.nextEventDelay);
        }

    }
